import React, { SVGProps } from "react";

export default function ProductsIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 27 27" width={27} height={27} {...props}>
      <path
        d="M4.794 25.218l-.758-.035c-1.104-.056-1.986-.73-2.057-1.588l-.024-.294a80.199 80.199 0 010-14.015l.024-.298c.075-.846.953-1.517 2.053-1.588h.397a177.818 177.818 0 0118.286 0h.397c1.1.056 1.986.727 2.053 1.588l.024.298a80.199 80.199 0 010 14.015l-.024.301c-.075.842-.949 1.513-2.049 1.589a179.26 179.26 0 01-18.322.027zM6.418 2.41v-.112c.047-.317.587-.567 1.262-.587h.238c3.748-.115 7.512-.115 11.26 0h.238c.675.02 1.215.27 1.263.587l.032.111M3.639 5.586l.023-.223c.064-.631.814-1.135 1.755-1.19h.33c5.205-.235 10.43-.235 15.634 0h.33c.94.043 1.691.547 1.755 1.19l.024.223"
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.588}
      />
    </svg>
  );
}
